import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../utils/api";

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function Googlelogin() {
  const navigate = useNavigate();

  return (
    <GoogleLogin
      onSuccess={async (credentialResponse) => {
        try {
          const decoded = jwtDecode(credentialResponse.credential);
          // Exchange Google token for our backend JWT
          const res = await fetch(`${API_BASE_URL}/api/auth/google-login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: decoded.email, name: decoded.name })
          });
          if (!res.ok) throw new Error('Failed to sign in');
          const data = await res.json();

          localStorage.setItem("isAuthenticated", "true");
          localStorage.setItem("token", data.access_token);
          localStorage.setItem("tenantId", data.accountId || decoded.email);
          localStorage.setItem("user", JSON.stringify({ email: decoded.email, name: decoded.name }));

          navigate("/dashboard");
        } catch (e) {
          console.error('Google sign-in failed:', e);
        }
      }}
      onError={() => {
        console.log("Login Failed");
      }}
    />
  );
}

export default Googlelogin;